// src/services/api/courierCompany.js
import { apiClient } from './base';

/**
 * Get all active courier companies
 * Used when assigning couriers to a business
 */
export const getAllCourierCompanies = async () => {
  try {
    const response = await apiClient.get('/courier-companies');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get a single courier company by ID
 * @param {number} courierCompanyId - The courier company ID
 */
export const getCourierCompany = async (courierCompanyId) => {
  try {
    const response = await apiClient.get(`/courier-companies/${courierCompanyId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};